module.exports = __webpack_public_path__ + "img/羚羊角.74064e35.jpg";